import Vue from "vue";
import Router from "vue-router";
import loginUtil from "@/util/loginUtil";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import {mainMenu, mainNotMenu, notMain} from "./routerBuilder";

Vue.use(Router);

const routes = [
  notMain("登录", "login", "main/Login"),
  notMain("跳转登录", "loginByToken", "main/LoginByToken"),
  notMain("调试区域看板", "kb/ts", "kanban/TiaoShiKanban"),
  notMain("装门区域看板", "kb/zm", "kanban/ZhuangMenKanban"),
  notMain("流水线看板", "kb/lsx/:lineNO", "kanban/LiuShuiXianKanban"),
  notMain("物流部总看板", "kb/wlb", "kanban/LogisticMainKanban"),
  notMain("仓库看板", "kb/ck", "kanban/CangKuKanban"),
  notMain("操纵包装区域看板", "kb/czbz", "kanban/CaoZongBaoZhuangKanban"),
  notMain("外召包装区域看板", "kb/wzbz", "kanban/WaiZhaoBaoZhuangKanban"),
  notMain("操纵测试区域看板", "kb/czcs", "kanban/CaoZongCeShiKanban"),
  notMain("控制柜报告打印", "kzgInspectionMultiPrintPage", "purchase/kzgReport/KZGInspectionMultiPrintPage"),
  notMain(
    "操纵流水线看板",
    "kb/czlsx/:lineNO",
    "kanban/CaoZongLiuShuiXianKanban",
  ),
  notMain(
    "外召流水线看板",
    "kb/wzlsx/:lineNO",
    "kanban/WaiZhaoLiuShuiXianKanban",
  ),
  notMain(
    "轿顶流水线看板",
    "kb/jdlsx/:lineNO",
    "kanban/JiaoDingLiuShuiXianKanban",
  ),
  notMain("控制柜电子看板", "kb/kzg", "kanban/KZGKanban"),
  notMain("电气仓电子看板", "kb/warehouse/Dq", "kanban/DqKanban"),
  notMain("部件仓电子看板", "kb/warehouse/Bj", "kanban/BjKanban"),
  notMain("中间仓电子看板", "kb/warehouse/Middle", "kanban/MiddleKanban"),
  notMain("小包装电子看板", "kb/warehouse/Mipack", "kanban/MipackKanban"),
  notMain("大包装仓电子看板", "kb/warehouse/Mapack", "kanban/MapackKanban"),
  notMain(
    "收货处电子看板",
    "kb/warehouse/ShouHuoKanban",
    "kanban/ShouHuoKanban",
  ),
  notMain(
    "产品预览",
    "productPreview/:id",
    "information/Product/ProductPreview",
  ),
  notMain(
    "产品展示列表",
    "productShowList",
    "information/Product/ProductShowList",
  ),
  notMain("部件看板", "kb/bj", "kanban/BuJianKanban"),
  notMain(
    "商务申请详情",
    "BusinessApplicationDetail/:businessApplicationID",
    "salesManage/businessApplication/BusinessApplicationDetail",
  ),
  notMain(
    "定价申请详情",
    "BusinessApplicationPriceApplyDetail/:businessApplicationID",
    "salesManage/businessApplicationPriceApply/BusinessApplicationPriceApplyDetail",
  ),
  notMain("序列号查询", "stepsigriner/serialNo", "stepsigriner/Search"),
  notMain(
    "原材料检验记录",
    "printRMIR/:id",
    "purchase/inspectionIncoming/printRawMaterialInspectionRecord",
  ),
  notMain("pdf阅读", "pdf", "document/Pan/PdfReader"),
  notMain("统计分析菜单", "menuList", "statistics/menuList"),
  notMain(
    "完成效率统计报表",
    "completionEfficiency",
    "statistics/CompletionEfficiency",
  ),
  notMain(
    "销售额区域汇总",
    "regionalSalesSummary",
    "statistics/RegionalSalesSummaryList",
  ),
  notMain("产品列表", "pan/public/list", "statistics/ProductList"),
  notMain(
    "中间仓库统计数据",
    "invoiceCountList",
    "statistics/ShipmentInvoiceCountList",
  ),
  mainMenu("首页", "home", [
    {
      title: "首页",
      name: "Home",
      path: "/",
      componentPath: "main/Home",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "页面刷新",
      path: "/redirect/:path*",
      componentPath: "redirect/Redirect",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "审批_",
      name: "Approval",
      path: "/approval",
      componentPath: "workFlow/Approval",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "销售订单预览",
      name: "SalesOrderPreview",
      path: "/salesOrder",
      componentPath: "salesManage/salesOrder/SalesOrderPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "销售订单预览",
      name: "SalesOrderPreviewBySupplier",
      path: "/salesOrderPreviewBySupplier",
      componentPath: "salesManage/salesOrder/SalesOrderPreviewBySupplier",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "销售订单预览",
      name: "SalesOrderPreviewBySupplierNew",
      path: "/SalesOrderPreviewBySupplierNew",
      componentPath: "salesManage/salesOrder/SalesOrderPreviewBySupplierNew",
      authIndex: 0,
    },
    {
      title: "线缆流转单",
      name: "CablePrintProperty",
      path: "/CablePrintProperty",
      componentPath: "purchase/purchaseDeliveryNew/CablePrintProperty",
      authIndex: 0,
    },
    {
      title: "线缆流转单",
      name: "CablePrintPropertyDongLi",
      path: "/CablePrintPropertyDongLi",
      componentPath: "purchase/purchaseDeliveryNew/CablePrintPropertyDongLi",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "过程异常单预览",
      name: "ProcessExceptionsPreview",
      path: "/ProcessExceptionsPreview",
      componentPath: "purchase/processException/ProcessExceptionsPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "控制柜检验详情",
      name: "ControlBoxInspectionDetail",
      path: "/controlBoxInspection",
      componentPath:
        "scheduling/ControlBoxInspection/ControlBoxInspectionDetail",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "商务申请预览",
      name: "BusinessApplicationPreview",
      path: "/businessApplication",
      componentPath:
        "salesManage/businessApplication/BusinessApplicationPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "定价申请预览",
      name: "BusinessApplicationPriceApplyPreview",
      path: "/businessApplicationPriceApply",
      componentPath:
        "salesManage/businessApplicationPriceApply/BusinessApplicationPriceApplyPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "对账管理预览",
      name: "ReconcileOrderDetail",
      path: "/ReconcileOrderDetail",
      componentPath: "purchase/ReconcileOrder/ReconcileOrderDetail",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "售后维修预览",
      name: "MaintainPreview",
      path: "/Maintain",
      componentPath: "afterSalesManagement/Maintain/MaintainPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "预约申请预览",
      name: "AppointmentPreview",
      path: "/Appointment",
      componentPath: "afterSalesManagement/Appointment/AppointmentPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "PUI申请预览",
      name: "PUIPreview",
      path: "/PUI",
      componentPath: "afterSalesManagement/PUI/PUIPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "特批申请预览",
      name: "CsSpecialApplicationPreview",
      path: "/CsSpecialApplication",
      componentPath:
        "afterSalesManagement/CsSpecialApplication/CsSpecialApplicationPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "更换申请预览",
      name: "AppointmentPreview",
      path: "/Replacement",
      componentPath: "afterSalesManagement/Replacement/ReplacementPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "退货申请预览",
      name: "ReturnOrderPreview",
      path: "/ReturnOrderPreview",
      componentPath: "afterSalesManagement/ReturnOrder/ReturnOrderPreview",
      authIndex: 0,
    },
  ]),

  mainNotMenu([
    {
      title: "拆解订单预览",
      name: "DisassembleOrderPreview",
      path: "/DisassembleOrderPreview",
      componentPath: "afterSalesManagement/DisassembleOrder/DisassembleOrderPreview",
      authIndex: 0,
    },
  ]),


  mainNotMenu([
    {
      title: "特批申请预览",
      name: "SpecialApplicationPreview",
      path: "/SpecialApplication",
      componentPath: "purchase/SpecialApplication/SpecialApplicationPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "改进调查预览",
      name: "ImprovedSurveyPreview",
      path: "/ImprovedSurvey",
      componentPath: "purchase/ImprovedSurvey/ImprovedSurveyPreview",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "凯斯博唛头打印",
      name: "KSBPrintModel",
      path: "/KSBPrintModel",
      componentPath: "deliveryManage/KSBPrintModel",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "东南专用唛头打印",
      name: "DNZYPrintModel",
      path: "/DNZYPrintModel",
      componentPath: "deliveryManage/DNZYPrintModel",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "重庆富士唛头打印",
      name: "CQFSPrintModel",
      path: "/CQFSPrintModel",
      componentPath: "deliveryManage/CQFSPrintModel",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "四川富士唛头打印",
      name: "SCFSPrintModel",
      path: "/SCFSPrintModel",
      componentPath: "deliveryManage/SCFSPrintModel",
      authIndex: 0,
    },
  ]),
  mainNotMenu([
    {
      title: "伊士顿唛头打印",
      name: "YSDPrintModel",
      path: "/YSDPrintModel",
      componentPath: "deliveryManage/YSDPrintModel",
      authIndex: 0,
    },
  ]),

  mainNotMenu([
    {
      title: "谊新发货流程预览",
      name: "yiXinApplicationPreview",
      path: "/yiXinApplicationPreview",
      componentPath:
        "salesManage/yiXinShipmentApplication/yiXinApplicationPreview",
      authIndex: 0,
    },
  ]),

  mainNotMenu([
    {
      title: "预留单预览",
      name: "ReserveOrderPreview",
      path: "/ReserveOrderPreview",
      componentPath: "warehouse/ReserveOrder/ReserveOrderPreview",
      authIndex: 0,
    },
  ]),

  mainNotMenu([
    {
      title: "开票申请预览",
      name: "InvoiceApplicationPreview",
      path: "/InvoiceApplicationPreview",
      componentPath: "invoicingManagement/invoiceApplication/InvoiceApplicationPreview",
      authIndex: 0,
    },
    {
      title: "开票申请编辑",
      name: "InvoiceApplicationEdit",
      path: "/InvoiceApplicationEdit",
      componentPath: "invoicingManagement/invoiceApplication/InvoiceApplicationPreview",
      authIndex: 0,
    },
  ]),
  mainMenu("工作流", "workFlow", [
    {title: "待办列表", name: "TodoList", componentPath: "workFlow/TodoList", authIndex: 0},
    {title: "待办商务申请", name: "businessApplication", componentPath: "workFlow/BusinessApplication", authIndex: 235},
    {title: "已办工作", name: "HandledList", componentPath: "workFlow/HandledList", authIndex: 0},
    {title: "检验异常待办", name: "InspectionRepProjectLiort", componentPath: "workFlow/InspectionReport", authIndex: 0},
    {title: "过程异常待办", name: "ProcessException", componentPath: "workFlow/ProcessException", authIndex: 0},
    {title: "资料发布待办", name: "FileReleaseAgenda", componentPath: "workFlow/FileReleaseAgenda", authIndex: 0},
    {title: "对账管理待办", name: "ReconcileOrder", componentPath: "workFlow/ReconcileOrder", authIndex: 958},
    {title: "预约单申请待办", name: "AppointmentOrder", componentPath: "workFlow/AppointmentApprove", authIndex: 0},
    {title: "改进调查单待办", name: "ImprovedSurvey", componentPath: "workFlow/ImprovedSurvey", authIndex: 0},
    {title: "更换申请单待办", name: "Replacement", componentPath: "workFlow/ReplacementApprove", authIndex: 0},
    {title: "出货控制待办", name: "InspectionShipment", componentPath: "workFlow/InspectionShipment", authIndex: 0},
    {title: "PUI待办", name: "InspectionShipment", componentPath: "workFlow/PuiApprove", authIndex: 0},
    {title: "售后特批申请", name: "CsSpecialApprove", componentPath: "workFlow/CsSpecialApprove", authIndex: 0},
    {title: "售后维修待办", name: "Maintain", componentPath: "workFlow/Maintain", authIndex: 0},
    {title: "谊新发货待办", name: "YiXinApplication", componentPath: "workFlow/YiXinApplication", authIndex: 242},
    {title: "退货申请待办", name: "ReturnOrderApprove", componentPath: "workFlow/ReturnOrderApprove", authIndex: 467},
    {title: "订单拆解待办", name: "DisassembleOrderApprove", componentPath: "workFlow/DisassembleOrderApprove", authIndex: 471},
  ]),
  mainMenu("项目管理", "projectManage", [
    {
      title: "项目管理",
      name: "Program",
      componentPath: "projectManage/program/ProgramList",
      authIndex: 802,
    },
    {
      title: "任务管理",
      name: "Task",
      componentPath: "projectManage/task/TaskList",
      authIndex: 811,
    },
  ]),
  mainMenu("销售管理", "salesManage", [
    {
      title: "创建销售订单",
      name: "SalesOrderNew",
      componentPath: "salesManage/salesOrder/SalesOrderNew",
      authIndex: 179,
    },
    {
      title: "销售订单",
      name: "SalesOrder",
      componentPath: "salesManage/salesOrder/SalesOrder",
      authIndex: 138,
    },
    {
      title: "商务申请",
      name: "BusinessApplicationList",
      componentPath: "salesManage/businessApplication/BusinessApplicationList",
      authIndex: 235,
    },
    {
      title: "销售预测",
      name: "SalesForecastList",
      componentPath: "afterSalesManagement/SalesForecast/SalesForecastList",
      authIndex: 0,
    },
    {
      title: "销售预测记录",
      name: "SalesForecastRecordList",
      componentPath: "afterSalesManagement/SalesForecastRecord/SalesForecastRecordList",
      authIndex: 0,
    },
    {
      title: "销售预测汇总",
      name: "SalesForecastTotalList",
      componentPath: "afterSalesManagement/SalesForecastTotal/SalesForecastTotalList",
      authIndex: 0,
    },
    {
      title: "退货管理",
      name: "ReturnOrderList",
      componentPath: "afterSalesManagement/ReturnOrder/ReturnOrderList",
      authIndex: 0,
    },
    {
      title: "拆解订单管理",
      name: "DisassembleOrderList",
      componentPath: "afterSalesManagement/DisassembleOrder/DisassembleOrderList",
      authIndex: 0,
    },
    {
      title: "定价申请",
      name: "BusinessApplicationPriceApplyList",
      componentPath:
        "salesManage/businessApplicationPriceApply/BusinessApplicationPriceApplyList",
      authIndex: 226,
    },
    {
      title: "SAP数据同步日志",
      name: "BusinessDataChangeList",
      componentPath: "salesManage/businessDataChange/BusinessDataChangeList",
      authIndex: 227,
    },
    {
      title: "文件转换",
      name: "FileConvert",
      componentPath: "salesManage/fileConvert/FileConvert",
      authIndex: 228,
    },
    {
      title: "销售变更单",
      name: "SalesExportExcelList",
      componentPath: "salesManage/SalesExportExcel/SalesExportExcelList",
      authIndex: 726,
    },
    {title: "EID查询", name: "EIDList", componentPath: "salesManage/EID/EIDList", authIndex: 843},
    {title: "MES-多可", name: "MESDuoke", componentPath: "information/MESDuoke/MESDuokeList", authIndex: 437},
    {title: "生产照片", name: "ProductInfoList", componentPath: "salesManage/ProductInfo/ProductInfoList", authIndex: 846},
    {
      title: "关键部件查询",
      name: "CriticalComponentList",
      componentPath: "salesManage/CriticalComponent/CriticalComponentList",
      authIndex: 848,
    },
    {
      title: "谊新待发货订单",
      name: "ToDoYiXinApplication",
      componentPath: "salesManage/yiXinShipmentApplication/ToDoYiXinApplication",
      authIndex: 242,
    },
    {
      title: "谊新发货流程",
      name: "YiXinShipmentApplicationList",
      componentPath: "salesManage/yiXinShipmentApplication/yiXinApplicationList",
      authIndex: 242,
    },
  ]),
  mainMenu("开票管理", "invoicingManagement", [
    {
      title: "开票平台",
      name: "ToDoInvoiceList",
      componentPath:
        "invoicingManagement/invoiceApplication/ToDoInvoiceList",
      authIndex: 429,
    },

    {
      title: "开票申请",
      name: "InvoiceApplicationList",
      componentPath:
        "invoicingManagement/invoiceApplication/InvoiceApplicationList",
      authIndex: 429,
    },

    {
      title: "客户开票信息",
      name: "CustomerInvoiceInfoList",
      componentPath:
        "invoicingManagement/customerInvoiceInfo/CustomerInvoiceInfoList",
      authIndex: 587,
    },
    {
      title: "发票信息",
      name: "InvoiceInformationList",
      componentPath:
        "invoicingManagement/invoiceInformation/InvoiceInformationList",
      authIndex: 710,
    },
    {
      title: "冲销发票",
      name: "ReverseInvoiceList",
      componentPath: "invoicingManagement/reverseInvoice/ReverseInvoiceList",
      authIndex: 711,
    },
    {
      title: "清账管理",
      name: "ClearingManagementList",
      componentPath:
        "invoicingManagement/clearingManagement/ClearingManagementList",
      authIndex: 713,
    },
  ]),
  mainMenu("发运管理", "deliveryManage", [
    {
      title: "SAP发货订单",
      name: "DeliveryOrder",
      componentPath: "deliveryManage/DeliveryOrder",
      authIndex: 391,
    },
    {
      title: "发货地址更改登记",
      name: "ChangeAddressList",
      componentPath: "warehouse/ChangeAddress/ChangeAddressList",
      authIndex: 189,
    },
  ]),
  mainMenu("生产管理", "scheduling", [
    {
      title: "主排产计划",
      name: "Production",
      componentPath: "scheduling/Production",
      authIndex: -1,
    },
    {
      title: "日排产计划",
      name: "ProductionDaily",
      componentPath: "scheduling/Production_D",
      authIndex: -1,
    },
    {
      title: "控制柜检验",
      name: "ControlBoxInspection",
      componentPath: "scheduling/ControlBoxInspection/ControlBoxInspectionList",
      authIndex: 288,
    },
    {
      title: "匹配物料",
      name: "MaterialMatchList",
      componentPath: "scheduling/MaterialMatch/MaterialMatchList",
      authIndex: 725,
    },
    // {title: "主排产计划", name: "Production", componentPath: "scheduling/Production",authIndex: -1},
    // {title: "日排产计划", name: "ProductionDaily", componentPath: "scheduling/Production_D",authIndex: -1},
    // {title: "控制柜检验", name: "ControlBoxInspection", componentPath: "scheduling/ControlBoxInspection/ControlBoxInspectionList",authIndex: 288},
    // {title: "匹配物料", name: "MaterialMatchList", componentPath: "scheduling/MaterialMatch/MaterialMatchList",authIndex: 725},
  ]),
  mainMenu("仓库管理", "warehouse", [
    {
      title: "中间仓待办",
      name: "MiddleWarehouseList",
      componentPath: "warehouse/MiddleWarehouse/MiddleWarehouseList",
      authIndex: 717,
    },
    {
      title: "盘点明细",
      name: "InventoryDetail",
      componentPath: "warehouse/InventoryDetail/InventoryDetail",
      authIndex: 736,
    },
    {
      title: "预留单管理",
      name: "ReserveOrderList",
      componentPath: "warehouse/ReserveOrder/ReserveOrderList",
      authIndex: 406,
    },
  ]),
  mainMenu("控制柜扫描", "manageScan", [
    {
      title: "控制柜扫描",
      name: "CabinetScan",
      componentPath: "manageScan/CabinetScanList",
      authIndex: 504,
    },
  ]),
  mainMenu("质量管理", "manageScan", [
    {
      title: "特批申请单",
      name: "SpecialApplicationList",
      componentPath: "purchase/SpecialApplication/SpecialApplicationList",
      authIndex: 0,
    },
    {
      title: "改进调查单",
      name: "ImprovedSurveyList",
      componentPath: "purchase/ImprovedSurvey/ImprovedSurveyList",
      authIndex: 0,
    },
    {
      title: "出货控制检验",
      name: "InspectionShipmentList",
      componentPath: "purchase/inspectionShipment/InspectionShipmentList",
      authIndex: 0,
    },
    {
      title: "入库检验",
      name: "InspectionReportList",
      componentPath: "purchase/inspectionReport/InspectionReportList",
      authIndex: 831,
    },
    {
      title: "来料检验",
      name: "InspectionIncomingList",
      componentPath: "purchase/inspectionIncoming/InspectionIncomingList",
      authIndex: 835,
    },
    {
      title: "检验员待办",
      name: "InspectionBacklogList",
      componentPath:
        "purchase/inspectionIncoming/InspectionIncomingList_backlogList",
      authIndex: 835,
    },
    {
      title: "特殊检验绑定",
      name: "SpecialInspectsBindList",
      componentPath: "purchase/specialInspectsBind/SpecialInspectsBindList",
      authIndex: 834,
    },
    {
      title: "过程异常单",
      name: "ProcessExceptionsList",
      componentPath: "purchase/processException/ProcessExceptionsList",
      authIndex: 835,
    },
    {
      title: "异常单判责",
      name: "QualityJudgmentList",
      componentPath: "purchase/processException/QualityJudgmentList",
      authIndex: 831,
    },
    {
      title: "控制柜报告",
      name: "KZGReportList",
      componentPath: "purchase/kzgReport/KZGReportList",
      authIndex: 831,
    },
    {
      title: "控制柜报告-邮件",
      name: "KZGReportList",
      componentPath: "purchase/kzgReport/KZGReportSentEmailList",
      authIndex: 831,
    },
    {
      title: "科莱曼出货检-创建",
      name: "InspectionKLMList",
      componentPath: "purchase/Inspection_KLM/Inspection_KLMList",
      authIndex: 0,
    },
    {
      title: "科莱曼出货检-代办",
      name: "InspectionKLMList",
      componentPath: "purchase/Inspection_KLM/Inspection_KLMList",
      authIndex: 0,
    },
  ]),
  mainMenu("售后管理", "afterSalesManagement", [
    {
      title: "更换单申请",
      name: "ReplacementList",
      componentPath: "afterSalesManagement/Replacement/ReplacementList",
      authIndex: 0,
    },
    {
      title: "追加单申请",
      name: "ReplacementZJList",
      componentPath: "afterSalesManagement/Replacement/ReplacementZJList",
      authIndex: 0,
    },
    {
      title: "待办发货单",
      name: "DeLiveryMaterialList",
      componentPath: "afterSalesManagement/Replacement/DeLiveryMaterialList",
      authIndex: 0,
    },
    {
      title: "售后冲账",
      name: "TaskList",
      componentPath: "afterSalesManagement/BillTask/TaskList",
      authIndex: 896,
    },
    {
      title: "售后维修",
      name: "MaintainList",
      componentPath: "afterSalesManagement/Maintain/MaintainList",
      authIndex: 0,
    },
    {
      title: "预约申请",
      name: "AppointmentList",
      componentPath: "afterSalesManagement/Appointment/AppointmentList",
      authIndex: 0,
    },
    {
      title: "特批申请",
      name: "CsSpecialApplicationList",
      componentPath:
        "afterSalesManagement/CsSpecialApplication/CsSpecialApplicationList",
      authIndex: 0,
    },
    {
      title: "PUI申请",
      name: "PUI",
      componentPath: "afterSalesManagement/PUI/PUIList",
      authIndex: 0,
    },
    {
      title: "PUI责任待办",
      name: "DutyHandelList",
      componentPath: "afterSalesManagement/PUI/DutyHandelList",
      authIndex: 0,
    },
  ]),
  mainMenu("维修管理", "MaintenanceManage", [
    {
      title: "维修登记表",
      name: "RepairRegistration",
      componentPath:
        "maintenanceManage/RepairRegistration/RepairRegistrationTabs",
      authIndex: 0,
    },
    {
      title: "报废登记表",
      name: "ScrapRegistration",
      componentPath:
        "maintenanceManage/ScrapRegistration/ScrapRegistrationList",
      authIndex: 0,
    },
    {
      title: "维修分析模版",
      name: "AnalysisTemplate",
      componentPath: "afterSalesManagement/Maintain/AnalysisTemplateList",
      authIndex: 0,
    },
  ]),
  // mainMenu("仓库管理", "warehouse", [{ title: "中间仓待办", name: "MiddleWarehouseList", componentPath: "warehouse/MiddleWarehouse/MiddleWarehouseList", authIndex: 717 }]),
  mainMenu("采购管理", "purchase", [
    {
      title: "采购订单管理",
      name: "PurchaseOrderManagerList",
      componentPath: "purchase/purchaseOrderManager/PurchaseOrderManagerList",
      authIndex: 481,
    },
    // { title: "采购收货管理", name: "PurchaseReceivesList", componentPath: "purchase/purchaseReceives/PurchaseReceivesList", authIndex: 46 },
    {
      title: "电机采购收货记录",
      name: "PurchaseReceiveSnsList",
      componentPath: "purchase/purchaseReceiveSns/PurchaseReceiveSnsList",
      authIndex: 489,
    },
    {
      title: "电机采购收货",
      name: "PurchaseReceivePalletNOList",
      componentPath:
        "purchase/PurchaseReceivePalletNO/PurchaseReceivePalletNOList",
      authIndex: 735,
    },
    {
      title: "创建送货单",
      name: "PurchaseDeliveryList",
      componentPath: "purchase/purchaseDelivery/PurchaseDeliveryList",
      authIndex: 238,
    },
    {
      title: "采购订单管理V2",
      name: "PurchaseDeliveryNewList",
      componentPath: "purchase/purchaseDeliveryNew/PurchaseDeliveryNewList",
      authIndex: 481,
    },
    {
      title: "送货单管理",
      name: "DeliveryList",
      componentPath: "purchase/purchaseDelivery/DeliveryList",
      authIndex: 228,
    },
    {
      title: "创建要货计划",
      name: "PurchasePlanAdd",
      componentPath: "purchase/purchasePlan/PurchasePlanAdd",
      authIndex: 852,
    },
    {
      title: "要货计划管理",
      name: "PurchasePlanList",
      componentPath: "purchase/purchasePlan/PurchasePlanList",
      authIndex: 851,
    },
    {
      title: "我要对账",
      name: "ReconcileOrders",
      componentPath: "purchase/ReconcileOrder/CreateReconcileOrder",
      authIndex: 955,
    },
    {
      title: "对账单管理",
      name: "ReconcileOrderList",
      componentPath: "purchase/ReconcileOrder/ReconcileOrderList",
      authIndex: 956,
    },
    {
      title: "供应商EID",
      name: "SupplierEidList",
      componentPath: "purchase/supplierEid/SupplierEidList",
      authIndex: 956,
    },
    {
      title: "送货单扫描",
      name: "AogScan",
      componentPath: "purchase/purchaseDelivery/AogScan",
      authIndex: 283,
    },
    {
      title: "沃克斯门锁待办清单",
      name: "WKSMenSuoList",
      componentPath: "purchase/WKSMenSuoFile/WKSMenSuoToDoList",
      authIndex: 478,
    },
    {
      title: "沃克斯门锁清单",
      name: "AogScan",
      componentPath: "purchase/WKSMenSuoFile/WKSMenSuoList",
      authIndex: 479,
    },
  ]),
  mainMenu("设备管理", "em", [
    {
      title: "设备档案",
      name: "EquipmentList",
      componentPath: "em/Equipment/EquipmentList",
      authIndex: 91,
    },
    {
      title: "设备维修",
      name: "EMRepairOrderList",
      componentPath: "em/EMRepairOrder/EMRepairOrderList",
      authIndex: 95,
    },
    {
      title: "日期维护",
      name: "DataList",
      componentPath: "em/EMRepairOrder/DataList",
      authIndex: 95,
    },
    {
      title: "维修子单",
      name: "EMRepairOrderDetailList",
      componentPath: "em/EMRepairOrderDetail/EMRepairOrderDetailList",
      authIndex: 95,
    },
    {
      title: "完好率统计",
      name: "EMEquipmentIntactRateList",
      componentPath: "em/EMEquipmentIntactRate/EMEquipmentIntactRateList",
      authIndex: 230,
    },
    {
      title: "完好率统计记录",
      name: "EMEquipmentRatesList",
      componentPath: "em/EMEquipmentRates/EMEquipmentRatesList",
      authIndex: 236,
    },
    {
      title: "设备点检",
      name: "EMEquipmentcheckList",
      componentPath: "em/EMEquipmentcheck/EMEquipmentcheckList",
      authIndex: 636,
    },
    {
      title: "设备点检记录表",
      name: "EMEquipmentcheckrecordList",
      componentPath: "em/EMEquipmentcheckrecord/EMEquipmentcheckrecordList",
      authIndex: 640,
    },
  ]),
  mainMenu("看板管理", "kanban", [
    {
      title: "看板",
      name: "kanban",
      componentPath: "kanban/KanBanRouterPass",
      authIndex: 301,
    },
  ]),
  mainMenu("统计分析", "statistics", [
    {
      title: "谊新OTD",
      name: "OTD",
      componentPath: "statistics/OTD",
      authIndex: 84,
    },
    {
      title: "区域销售额汇总",
      name: "RegionalSummary",
      componentPath: "statistics/RegionalSalesSummaryList",
      authIndex: 905,
    },
    {
      title: "完成效率统计",
      name: "CompletionEfficiency",
      componentPath: "statistics/CompletionEfficiency",
      authIndex: 84,
    },
    {
      title: "中间仓库统计数据",
      name: "ShipmentInvoiceCountList",
      componentPath: "statistics/ShipmentInvoiceCountList",
      authIndex: 84,
    },
    {
      title: "601仓客户金额汇总",
      name: "CustomerAmountSummaryList",
      componentPath: "statistics/CustomerAmountSummaryList",
      authIndex: 158,
    },
    {
      title: "601仓客户金额明细",
      name: "CustomerAmountSummaryDetailList",
      componentPath: "statistics/CustomerAmountSummaryDetailList",
      authIndex: 158,
    },
    {
      title: "机器人销售员汇总",
      name: "RobotSalesSummaryList",
      componentPath: "statistics/RobotSalesSummaryList",
      authIndex: 113,
    },
    {
      title: "订单处理统计",
      name: "OrderProcessingList",
      componentPath: "statistics/OrderProcessingList",
      authIndex: 650,
    },
    {
      title: "每日发货金额报表",
      name: "DailyAmountShippedList",
      componentPath: "statistics/DailyAmountShippedList",
      authIndex: 718,
    },
    {
      title: "在用梯金额明细",
      name: "ZaiYongTiAmount",
      componentPath: "statistics/ZaiYongTiAmount",
      authIndex: 418,
    },
    {
      title: "导入订单统计",
      name: "ImportSalesOrderCountList",
      componentPath: "statistics/ImportSalesOrderCountList",
      authIndex: 444,
    },
    /*{title: "堆叠柱形图", name: "堆叠柱形图", componentPath: "statistics/Demo", authIndex: 0},*/
  ]),
  mainMenu("文档资料", "document", [
    {
      title: "产品资料管理",
      name: "Pan",
      componentPath: "document/Pan/PanList",
      authIndex: 642,
    },
    {
      title: "产品资料发布",
      name: "Pan",
      componentPath: "document/Release/Release",
      authIndex: 642,
    },
  ]),
  mainMenu("测试参数", "document", [
    {
      title: "广日参数",
      name: "GrTestParametersList",
      componentPath: "information/GrTestParameters/GrTestParametersList",
      authIndex: 861,
    },
    {
      title: "标准COP测试",
      name: "CopTestParameterList",
      componentPath: "information/CopTestParameter/CopTestParameterList",
      authIndex: 861,
    },
    {
      title: "蒂升轿顶测试记录",
      name: "ParametersJdDsList",
      componentPath: "information/ParameterJdDs/ParametersJdDsList",
      authIndex: 861,
    },
    {
      title: "G20轿顶盒参数",
      name: "ParametersG20JdList",
      componentPath: "information/ParametersG20Jd/ParametersG20JdList",
      authIndex: 861,
    },
    {
      title: "G20控制柜测试参数",
      name: "ParametersG20KzgList",
      componentPath: "information/ParametersG20Kzg/ParametersG20KzgList",
      authIndex: 861,
    },
    {
      title: "测试记录查询",
      name: "ProductDebugDataList",
      componentPath: "information/ProductDebugData/ProductDebugDataList",
      authIndex: 428,
    },
  ]),
  mainMenu("基本信息", "information", [
    {
      title: "网关信息管理",
      name: "GatewayManage",
      componentPath: "information/GatewayManage/GatewayList",
      authIndex: 449,
    },
    {
      title: "电子ID",
      name: "Electronic",
      componentPath: "information/Electronic/ElectronicList",
      authIndex: 751,
    },
    {
      title: "EID协议配置",
      name: "Electronic",
      componentPath: "information/EIDProSetting/EIDProSettingList",
      authIndex: 495,
    },
    {
      title: "产品类别管理",
      name: "ProductCategory",
      componentPath: "information/ProductCategory/ProductCategoryList",
      authIndex: 622,
    },
    {
      title: "产品介绍模板",
      name: "ProductIntroductionTemplate",
      componentPath:
        "information/ProductIntroductionTemplate/ProductIntroductionTemplateList",
      authIndex: 622,
    },
    {
      title: "产品管理",
      name: "Product",
      componentPath: "information/Product/ProductList",
      authIndex: 632,
    },
    {
      title: "产品价格表",
      name: "ProductPrice",
      componentPath: "information/ProductPrice/ProductPriceList",
      authIndex: 195,
    },
    {
      title: "产品接口",
      name: "ProductInterfaceList",
      componentPath: "information/ProductPrice/ProductInterfaceList",
      authIndex: 438,
    },
    {
      title: "轿顶分支价格",
      name: "BaseBranchCablePrices",
      componentPath: "information/BaseBranchCablePrices/BaseBranchCablePrices",
      authIndex: 195,
    },
    {
      title: "五大电缆价格",
      name: "CablePrices",
      componentPath: "information/CablePrices/CablePrices",
      authIndex: 195,
    },
    {
      title: "客户物料关系",
      name: "SAPCustomerMaterialMapping",
      componentPath:
        "information/SAPCustomerMaterialMapping/SAPCustomerMaterialMappingList",
      authIndex: 65,
    },
    {
      title: "客户特性管理",
      name: "SAPBaseCustomerPropertyValueMapping",
      componentPath:
        "information/SAPBaseCustomerPropertyValueMapping/SAPBaseCustomerMaterialMappingList",
      authIndex: 65,
    },
    {
      title: "客户木箱备注",
      name: "CustomerBoxList",
      componentPath: "information/CustomerBox/CustomerBoxList",
      authIndex: 443,
    },
    {
      title: "故障管理",
      name: "Fault",
      componentPath: "information/Fault/FaultList",
      authIndex: 631,
    },
    {
      title: "唛头尺寸配置",
      name: "ThyssenMarkRule",
      componentPath: "information/ThyssenMarkRule/ThyssenMarkRuleList",
      authIndex: 411,
    },
    {
      title: "客户管理",
      name: "Customer",
      componentPath: "information/Customer/CustomerList",
      authIndex: 721,
    },
    {
      title: "供应商管理",
      name: "SupplierManageList",
      componentPath: "information/SupplierManage/SupplierManageList",
      authIndex: 160,
    },
    {
      title: "供应商交期确认",
      name: "DeliveryDateConfirmList",
      componentPath: "information/DeliveryDateConfirm/DeliveryDateConfirmList",
      authIndex: 11,
    },
    {
      title: "SAP物料管理",
      name: "MaterialManagementList",
      componentPath: "information/MaterialManagement/MaterialManagementList",
      authIndex: 65,
    },
    {
      title: "部门管理",
      name: "DepartmentList",
      componentPath: "information/Department/DepartmentList",
      authIndex: 24,
    },
    {
      title: "员工管理",
      name: "EmployeeList",
      componentPath: "information/Employee/EmployeeList",
      authIndex: 36,
    },
    {
      title: "职位管理",
      name: "PositionList",
      componentPath: "information/Position/PositionList",
      authIndex: 64,
    },
    {
      title: "区域管理",
      name: "DistrictList",
      componentPath: "information/District/DistrictList",
      authIndex: 134,
    },
    {
      title: "付款方式",
      name: "PayMannerList",
      componentPath: "information/PayManner/PayMannerList",
      authIndex: 210,
    },
    {
      title: "付款节点配置",
      name: "PayNodeList",
      componentPath: "information/PayNode/PayNodeList",
      authIndex: 205,
    },
    {
      title: "客户付款方式",
      name: "CustomerPayMethodList",
      componentPath: "information/CustomerPayMethod/CustomerPayMethodList",
      authIndex: 215,
    },
    {
      title: "产线工序配置",
      name: "WorkLineInfoList",
      componentPath: "information/WorkLineInfo/WorkLineInfoList",
      authIndex: 602,
    },
    {
      title: "产线工序处理人",
      name: "WorkLineInfoHandlerList",
      componentPath: "information/WorkLineInfoHandler/WorkLineInfoHandlerList",
      authIndex: 602,
    },
    {
      title: "产线物料组配置",
      name: "MaterialGroupConfigList",
      componentPath: "information/MaterialGroupConfig/MaterialGroupConfigList",
      authIndex: 671,
    },
    {
      title: "关键部件",
      name: "KeyComponentList",
      componentPath: "information/KeyComponent/KeyComponentList",
      authIndex: 651,
    },
    {
      title: "控制柜部件",
      name: "KZGComponentList",
      componentPath: "information/KZGComponent/KZGComponentList",
      authIndex: 661,
    },
    {
      title: "合理化建议",
      name: "RSSuggestionsList",
      componentPath: "information/RSSuggestions/RSSuggestionsList",
      authIndex: 714,
    },
    {
      title: "合理化建议记录",
      name: "RSRecordList",
      componentPath: "information/RSRecord/RSRecordList",
      authIndex: 715,
    },
    {
      title: "测试台产品映射",
      name: "MaterialStandardMappingTabs",
      componentPath: "information/MaterialStandardMapping/MaterialStandardMappingTabs",
      authIndex: 497,
    },
    {
      title: "自定义相关性",
      name: "RuleCustomList",
      componentPath: "information/RuleCustom/RuleCustomList",
      authIndex: 513,
    },
    {
      title: "蒂升参数配置",
      name: "ThkMaterialTabs",
      componentPath: "information/ThkMaterial/ThkMaterialTabs",
      authIndex: 515,
    },
    {
      title: "沃克斯台账-草稿",
      name: "WksDelivery",
      componentPath: "information/WksDelivery/WksDeliveryList",
      authIndex: 0,
    },
    {
      title: "沃克斯台账-正式",
      name: "WksDelivery",
      componentPath: "information/WksDelivery/WksDeliveryListByProd",
      authIndex: 0,
    },
  ]),
  mainMenu("系统管理", "SystemInfo", [
    {
      title: "账套管理",
      name: "AccountSetList",
      componentPath: "SystemInfo/AccountSet/AccountSetList",
      authIndex: 719,
    },
    {
      title: "角色管理",
      name: "RoleList",
      componentPath: "SystemInfo/role/RoleList",
      authIndex: 83,
    },
    {
      title: "个人信息",
      name: "ProfilesList",
      componentPath: "SystemInfo/profiles/ProfilesList",
      authIndex: -1,
    },
    {
      title: "表单分配",
      name: "WFConfigList",
      componentPath: "SystemInfo/WFConfig/WFConfigList",
      authIndex: 152,
    },
    {
      title: "订单分配管理",
      name: "WFDistributeConfigList",
      componentPath: "SystemInfo/WFDistributeConfig/WFDistributeConfigList",
      authIndex: 154,
    },
    {
      title: "系统功能",
      name: "SystemFunctionTree",
      componentPath: "SystemInfo/systemFunction/SystemFunctionTree",
      authIndex: 101,
    },
    {
      title: "系统菜单",
      name: "SystemNavItemList",
      componentPath: "SystemInfo/systemNavItem/SystemNavItemList",
      authIndex: 101,
    },
    {
      title: "用户管理",
      name: "UserList",
      componentPath: "SystemInfo/SystemUser/UserList",
      authIndex: 101,
    },
    {
      title: "流水单配置",
      name: "OnePieceFlow",
      componentPath: "SystemInfo/OnePieceFlow/OnePieceFlow",
      authIndex: 841,
    },
  ]),
];

const router = new Router({
  base: process.env.BASE_URL,
  routes: routes,
});

const whiteUris = ["/login"]; // 白名单,无需登录即可访问

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (
    to.path.indexOf("/menuList") !== -1 ||
    to.path.indexOf("/pdf") !== -1 ||
    to.path.indexOf("/completionEfficiency") !== -1 ||
    to.path.indexOf("/invoiceCountList") !== -1 ||
    to.path.indexOf("/kb/") !== -1 ||
    to.path.indexOf("/manageScan/") !== -1 ||
    to.path.indexOf("/productPreview") !== -1 ||
    to.path.indexOf("/loginByToken") !== -1 ||
    to.path.indexOf("/pan/public/list") !== -1 ||
    to.path.indexOf("/stepsigriner/serialNo") !== -1 ||
    whiteUris.indexOf(to.path) !== -1 ||
    loginUtil.isLogin()
  ) {
    // 在白名单当中或者已经登录,放行
    next();
  } else {
    toLogin(to.fullPath);
  }
});

router.afterEach(() => {
  NProgress.done();
});

export const toLogin = () => {
  router.push({
    path: "/login",
  });
};

export {routes};
export default router;
